import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import { connect } from 'react-redux'
import { History } from 'history'

import { selectUser } from '../../reducers'
import UserCreateTicketForm from './userCreateTicketForm'
import { UserBanner } from './userBanner'
import { createTicket, fetchUser } from './userActions'
import { User } from '../../core/types'

export function formatTicketFormData(values, userId, origin) {
  const returnUrl = `${origin}/users/${userId}`
  return Object.assign({}, values, { returnUrl, userId })
}

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  user: User
  fetchUser: Callback
  match: Match<ParamsID>
  createTicket: Callback<Promise<any>>
  history: History
}

export class UserCreateTicket extends Component<Props> {
  static displayName = 'UserBannerCreateTicket'

  componentWillMount() {
    const { fetchUser, match } = this.props
    fetchUser(match.params.id)
  }

  onSubmit = (values) => {
    const { user, createTicket, history } = this.props
    const domain = window.location.origin
    return createTicket(
      formatTicketFormData(values, user.id, domain),
      user
    ).then(() => {
      history.goBack()
    })
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const { user } = this.props
    if (isEmpty(user)) return null

    return (
      <div className="create-ticket">
        <UserBanner user={user} context="User" />
        <UserCreateTicketForm onSubmit={this.onSubmit} cancel={this.onCancel} />
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    user: selectUser(state.users, match.params.id),
  }
}

export default connect(mapStateToProps, { fetchUser, createTicket })(
  UserCreateTicket
)
